import { createReducer, on, Action } from '@ngrx/store';
import { LoadState } from '@nx-ng/types';
import { OrderActions } from '../actions';
import { ApiError, Order } from '../client/src/models';

export interface IOrderState {
  order?: Order;
  loaded: LoadState;
  error?: ApiError | string;
}

export const initialState: IOrderState = {
  loaded: LoadState.NOT_LOADED,
};

const checkoutReducer = createReducer(
  initialState,
  on(OrderActions.orderAPI_loadOrder, (state) => ({
    ...state,
    loaded: LoadState.LOADING,
    error: undefined,
  })),
  on(
    OrderActions.orderAPI_loadOrderSuccess,
    (state, { response }: { response: Order }) => ({
      ...state,
      order: response,
      loaded: LoadState.LOADED,
    })
  ),
  on(OrderActions.orderAPI_loadOrderFailure, (state, { error }) => ({
    ...state,
    error,
    loaded: LoadState.FAILED,
  })),
  on(OrderActions.clearOrder, (state) => ({
    ...state,
    order: undefined,
    loaded: LoadState.NOT_LOADED,
  }))
);

export function reducer(state: IOrderState | undefined, action: Action) {
  return checkoutReducer(state, action);
}
